module.exports = "/images/project-deliverable.svg?299076bddf48d9c636a58e71068d2efe";